import { Box, Typography, Button } from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useNavigate } from "react-router-dom";

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      p={2}
    >
      <ReportProblemIcon sx={{ fontSize: 80, color: "error.main" }} />
      <Typography variant="h3" gutterBottom mt={2}>
        Forbidden
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        You don't have permission to access this page.
      </Typography>
      <Button variant="contained" color="green" onClick={() => navigate("/")}>
        <Typography color="white">Go to Home</Typography>
      </Button>
    </Box>
  );
};

export default Forbidden;
